import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { UtilsService } from 'src/app/utils/utils.service';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { DrinkingWaterDataService } from './drinking-water-data.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-drinking-water-stress',
  templateUrl: './drinking-water-stress.component.html',
  styleUrls: ['./drinking-water-stress.component.scss']
})
export class DrinkingWaterStressComponent implements OnInit {

  ruralSelected:boolean = true;

  constructor(private utils: UtilsService, public DWSDataService : DrinkingWaterDataService) {}

  ngOnInit() {
    this.utils.getRuralUrbanToggle().subscribe(value => {
      if(this.ruralSelected!=value) {
        this.ruralSelected = value;
      }
    })
  }

  ruralUrbanToggle() {
    this.ruralSelected = !this.ruralSelected;
    this.utils.setRuralUrbanToggle(this.ruralSelected);
  }

  ngOnDestroy(){
    // this.utils.setRuralUrbanToggle(true);
    //console.log('Back to Rural')
  }

}
